import Radio from "backbone.radio";
import { useEffect } from "react";

import { store } from "common/store";

import { ensureErrorCallback } from "common/components/error";

import { AuthRoute, useRouteMatch, useParams } from "extensions/react-router";

export function AlertsRouter() {
    const { url } = useRouteMatch();
    return (
        <>
            <AuthRoute
                path={`${url}/alerts2/:context?/:id?`}
                authenticated={(state) => state.permissions.user_permissions.feature_alerts || Object.values(state.permissions.user_permissions.alerts_view)}
                component={AlertsComponent}
            />
            <AuthRoute
                path={`${url}/alerts`}
                authenticated={(state) => state.permissions.user_permissions.feature_alerts || Object.values(state.permissions.user_permissions.alerts_view)}
                component={AlertsComponent}
            />
            <AuthRoute
                path={`${url}/preferences/alerts2/:context?/:id?`}
                authenticated={(state) => state.permissions.user_permissions.feature_alerts || Object.values(state.permissions.user_permissions.alerts_view)}
                component={AlertsComponent}
            />
        </>
    );
}

function AlertsComponent() {
    const { context, id } = useParams();
    useEffect(() => {
        async function main() {
            try {
                const { AlertsManagerRedux } = await import("merchant/features/alerts2/manager/alertsManager");
                const { SET_ALERTS_FROM_URL_PARAMS } = await import("common/actions/alerts");
                const { SET_SNAPSHOT_FROM_URL_PARAMS } = await import("common/actions/snapshots");
                // Set params to redux store
                
                if (context === "inbox") {
                    store.dispatch(SET_ALERTS_FROM_URL_PARAMS({ context }));
                    SET_SNAPSHOT_FROM_URL_PARAMS(id);
                } else {
                    store.dispatch(SET_ALERTS_FROM_URL_PARAMS({ context, id }));
                }
                Radio.channel("main").request("show:app:view", <AlertsManagerRedux />, {
                    name: "Alerts",
                    waitForAttach: true,
                    hideDatePicker: true
                });
            } catch (error) {
                ensureErrorCallback(error);
            }
        }
        main();
    }, [context, id]);
    return null;
}
